
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRunningFill as ObiRunningFillElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-running-fill.js';
 
 
 

 
 export const ObiRunningFill = createComponent({
   react: React,
   tagName: 'obi-running-fill',
   elementClass: ObiRunningFillElement,
   events: {
     
   }
  });
 
 